import { TceSummaryServiceInterface } from 'domain/services';
import {
  SummaryOfTerminationTermsUseCaseInterface,
  TceSummaryBySituationUseCaseInterface,
  TceManagementUseCaseInterface,
} from 'domain/usecases';

export class TceSummaryService implements TceSummaryServiceInterface {
  constructor(
    private readonly _summaryOfTerminationTermsUseCase: SummaryOfTerminationTermsUseCaseInterface,
    private readonly _tceSummaryBySituationUseCase: TceSummaryBySituationUseCaseInterface,
    private readonly _tceManagementUseCase: TceManagementUseCaseInterface,
  ) {}

  async summaryOfTerminationTerms(
    params: SummaryOfTerminationTermsUseCaseInterface.Params,
  ): Promise<SummaryOfTerminationTermsUseCaseInterface.Result> {
    return await this._summaryOfTerminationTermsUseCase.execute(params);
  }

  async tceSummaryBySituation(
    params: TceSummaryBySituationUseCaseInterface.Params,
  ): Promise<TceSummaryBySituationUseCaseInterface.Result> {
    return await this._tceSummaryBySituationUseCase.execute(params);
  }

  async tceManagement(
    params: TceManagementUseCaseInterface.Params,
  ): Promise<TceManagementUseCaseInterface.Result> {
    return await this._tceManagementUseCase.execute(params);
  }
}
